import { makeStyles } from '@mui/styles';
import Button from 'apollo-react/components/Button';
import Grid from 'apollo-react/components/Grid';
import ChevronLeft from 'apollo-react-icons/ChevronLeft';
import React from 'react';
import { useHistory } from 'react-router-dom';

import { HOME } from '../../constants/Urls';
import { useTranslation } from '../../custom-hooks/useTranslation';
import { getUITA } from '../../utils/commonUtils';

const useStyles = makeStyles({
  backButton: {
    padding: '0px 9.5px',
  },
});

const BackButton = ({ isCertificationPage, isFormPage, isPowerBIPage }) => {
  const classes = useStyles();
  const history = useHistory();
  const translateString = useTranslation();
  const backButtonURL = sessionStorage.getItem('backButtonURL');

  const handleBackButtonClick = () => {
    if (history.length > 1 && backButtonURL) {
      history.push(backButtonURL);
    } else {
      history.push(`${HOME}`);
    }
  };

  return (
    backButtonURL && (
      <Grid
        container
        spacing={isPowerBIPage ? 0 : 1}
        direction="row"
        justifyContent="flex-end"
        ui-ta={getUITA('BackButtonContainer')}
        style={{
          marginBottom: isPowerBIPage || isFormPage ? 0 : 4,
          paddingRight: isCertificationPage && 14,
        }}
      >
        <Grid item ui-ta={getUITA('BackButton')}>
          <Button
            variant="secondary"
            color="secondary"
            icon={ChevronLeft}
            className={classes.backButton}
            onClick={handleBackButtonClick}
          >
            {translateString('Back to Records')}
          </Button>
        </Grid>
      </Grid>
    )
  );
};

export default BackButton;
